import { useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const LoadCards = (sellType: string) => {
  const [data, setData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost('finance')

  const body: any = {
    unidadeId: getUnitId(),
    tipoCliente: sellType == 'VENDA_RAPIDA' ? 'CLIENTE' : 'ALUNO'
  }

  const loadCards = (idUsuario: string) => {
    body.idUsuario = idUsuario
    if (!loading) {
      setLoading(true)
      httpClientPost('/cartoes/filtro', body)
        .then((response) => {
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: `Cartão numeração final: ${item.numero}`,
              value: item.id.toString()
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  return {
    loadCards,
    data
  }
}
